import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import requests from '../../utils/stls/Request';
import GenericTemplate from '../../templates/GenericTemplate';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import MUIDataTable from "mui-datatables";
import FromTextFieldKojoCd from '../../components/TextField/TextFieldKojoCd';
import { chkHalfWidth, chkEmpty } from '../../common/chkTextValue';
import {Auth} from 'aws-amplify';

const P01Prg001Kata002: React.FC = () => {
  //変数定義
  const [post, setPosts] = useState([])
  //工場コード
  const [kojo, setKojo] = useState('');
  const [kojoError, setKojoError] = useState("");

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  //requests.p01Prg001Dataにリクエストする関数。
  const fetchRequest = async() => {
    setPosts([])

    //requestを投げるURL作成
    const URL = process.env.REACT_APP_APIURL_STLS + requests.p01Mst001Loc + '/' + kojo
    const AuthToken = (await Auth.currentSession()).getIdToken().getJwtToken()
    axios.get(URL,
      {
        headers: {
          "X-API-KEY": process.env.REACT_APP_APIKEY_STLS || "",
          "Authorization": AuthToken || "",
        },
      }).then((res) => {
        //成功したら Posts に result を格納。
        setPosts(res.data.result)
        if (res.data.result.length === 0) {
          alert('データはありません')
        }
        console.debug(res.data.result)
      }).catch(error => {
        console.log(error);
        alert('検索に失敗しました')
      }).finally(() => {
        setLoading(false);
      });
  };

  //検索・ボタン押下時の処理 
  const handleClick = (() => {
    let errMsg = ""
    //未入力チェック
    errMsg = chkEmpty(kojo)
    if (errMsg.length > 0) {
      setKojoError(errMsg)
      alert('検索条件を入力してください');
      return;
    }
    //半角文字チェック 
    errMsg = chkHalfWidth(kojo)
    if (errMsg.length > 0) {
      setKojoError(errMsg)
      alert(errMsg);
      return;
    }

    if (!loading) {
      setSuccess(false);
      setLoading(true);
      //apiコールする関数を呼び出す
      fetchRequest()
      setSuccess(true);
    }
  })

  //入力値チェック処理：工場コード
  const chkKojo = (event: any) => {
    let val = event.target.value
    setKojoError(chkHalfWidth(val))
    setKojo(val)
  }

  const column = [
    { name: "loc", label: "工場コード", 
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 0, background: "white", zIndex: 100 } }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 0, top: 0, background: "white", zIndex: 101 } })
      }
    },
    { name: "company", label: "工場名", },
    { name: "description_kana", label: "工場名（カナ）", },
    { name: "abbreviation", label: "略称", },
    { name: "main_factory", label: "主管工場", },
    { name: "rep_loc", label: "代表工場", },
    { name: "plant_div", label: "工場区分",
      options: {
        hint: ('０：主管 １：自社工場 ２：センター ３：協力工場 ４：ＯＥＭ ９：その他')
      }
    },
    { name: "vend_num", label: "取引先コード", },
    { name: "representative_cost", label: "代表原価分類", },
    { name: "postal_code", label: "郵便番号",
      // options: {
      //   //郵便番号上６桁と郵便番号下２桁を統合
      //   customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
      //     return '〒' + post[tableMeta.rowIndex]['postal_code_upper_6_digit'] + post[tableMeta.rowIndex]['postal_code_under_2_digit'];
      //   }
      // },
    },
    { name: "address1", label: "住所", },
    { name: "phone", label: "ＴＥＬ", },
    { name: "fax", label: "ＦＡＸ", },
    
    // { name: "cost_classification1", label: "原価分類1", },
    // { name: "cost_classification2", label: "原価分類2", },
    // { name: "cost_classification3", label: "原価分類3", },
    // { name: "cost_classification4", label: "原価分類4", },
    // { name: "management_classification1", label: "管理分類1", },
    // { name: "management_classification2", label: "管理分類2", },
    // { name: "management_classification3", label: "管理分類3", },
    // { name: "management_classification4", label: "管理分類4", },
    // { name: "center2", label: "センター2", },
    // { name: "center3", label: "センター3", },
    // { name: "center4", label: "センター4", },
    // { name: "consumption_department_code", label: "消費部署コード", },
    // { name: "inventory_div", label: "棚卸区分",
    //   options: {
    //     hint: ('△：棚番のみ １：全品目')
    //   }
    // },
    // { name: "closing_div", label: "本締区分",
    //   options: {
    //     hint: ('△：仮締あり １：なし')
    //   }
    // },
    // { name: "Inventory_reenter", label: "棚卸再入力フラグ",
    //   options: {
    //     hint: ('△：必要 １：不要')
    //   }
    // },
    // { name: "preparation", label: "予備", },
    // { name: "postal_code_upper_6_digit", label: "郵便番号上６桁", },
    // { name: "postal_code_under_2_digit", label: "郵便番号下２桁", },
    // { name: "terminal_use", label: "主管端末区分",
    //   options: {
    //     hint: ('△：東芝 １：ＩＢＭ ２：ＮＥＣ')
    //   }
    // },
    // { name: "mrp", label: "ＭＲＰ対応マーク",
    //   options: {
    //     hint: ('△：なし １：あり')
    //   }
    // },
    // { name: "cardboard", label: "段ボール発注可否",
    //   options: {
    //     hint: ('△：発注可能 １：不可')
    //   }
    // },
    // { name: "enactment_goods", label: "制定品",
    //   options: {
    //     hint: ('△：工場在庫 １：センタ払')
    //   }
    // },
    // { name: "special_order_item", label: "特注品",
    //   options: {
    //     hint: ('△：メーカ直 １：センタ経由')
    //   }
    // },
    // { name: "center1", label: "センター1", },
    // { name: "standard_process_payout_date", label: "標準払出日", },
    // { name: "station", label: "工場ステーション", },
  ];

  return (
    <GenericTemplate title="" >
      <Stack spacing={1} direction="column" >
        <Stack spacing={2} direction="row">
          {/* 工場コード */}
          <FromTextFieldKojoCd onChange={chkKojo}
            helperText={kojoError}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button variant="contained"
                sx={buttonSx}
                disabled={loading}
                onClick={() => { handleClick(); }}>
                検索
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              )}
            </Box>
          </Box>
        </Stack>
        <div style={{ height: '50%', width: '100%', }}>
          <MUIDataTable
            title="保管場所(stls)"
            data={post}
            columns={column}
            options={{
              selectableRows: 'none',
              rowsPerPage: 20,
              viewColumns: false,
              rowsPerPageOptions: [20, 50, 100],
              sort: false,
              print: false,
              setTableProps: () => {
                return {
                  // padding: 'none',
                  size: "small",
                  style: { whiteSpace: "nowrap" }
                };
              },
            }}
          />
        </div>
      </Stack>
    </GenericTemplate>
  )
}

export default P01Prg001Kata002